import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { FiBusinessUnitViewProfileTabBase } from '@fi-app/business-unit/business-unit-view-dialog/fi-business-unit-view-tab-group/fi-business-unit-view-profile-tab-base';
import { DataFieldSectionType } from '@fi-app/business-unit/data-field-section-type';

@Component({
    selector: 'fi-business-unit-view-tab-group',
    templateUrl: './fi-business-unit-view-tab-group.component.html',
    styleUrls: ['./fi-business-unit-view-tab-group.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-business-unit-view-tab-group' },
    standalone: false,
})
export class FiBusinessUnitViewTabGroupComponent extends FiBusinessUnitViewProfileTabBase {
    DataFieldSectionType = DataFieldSectionType;

    isContactTabShown(): boolean {
        return (
            !!this.businessUnit.EmailAddressContacts?.length ||
            !!this.businessUnit.PhoneNumberContacts?.length ||
            !!this.businessUnit.Addresses?.length
        );
    }

    isOtherTabShown(): boolean {
        return this.dataFieldHelperService.isCustomDataFieldValueDefined(this.businessUnitDataFields);
    }

    getDataFieldsBySectionType(sectionType: DataFieldSectionType) {
        return this.dataFieldHelperService.getDataFieldsBySectionType(this.businessUnitDataFields, sectionType);
    }
}
